/* unplugin-vue-components disabled */import { render } from "./TeachData.vue?vue&type=template&id=4d3325e0&scoped=true"
import script from "./TeachData.vue?vue&type=script&lang=js"
export * from "./TeachData.vue?vue&type=script&lang=js"

import "./TeachData.vue?vue&type=style&index=0&id=4d3325e0&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3325e0"]])

export default __exports__